module.exports = __webpack_public_path__ + "static/media/Cunning.3ec01c0d.svg";